import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcCallIcon, IcEditIcon, IcSCopyIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';

import { MetaBlock } from '../MetaBlock/MetaBlock';
import styles from './PhoneNumber.styles.m.css';

interface IPhoneNumberProps {
  className: string;
  phoneNumber: string;
  onChangePhone?(): void;
}

export const PhoneNumber: FC<IPhoneNumberProps> = observer(
  ({ className, phoneNumber, onChangePhone }) => {
    const { t } = useTranslation();

    const copyToClipboard = useCopyToClipboard(phoneNumber, t('profile_user_number_copied'));

    return (
      <MetaBlock
        className={className}
        label={t('profile_user_phone_hint')}
        Icon={IcCallIcon}
        Actions={
          <>
            {onChangePhone && (
              <IconButton
                Icon={IcEditIcon}
                onClick={onChangePhone}
              />
            )}

            <IconButton
              Icon={IcSCopyIcon}
              onClick={copyToClipboard}
            />
          </>
        }
      >
        <button
          className={styles.link}
          onClick={copyToClipboard}
        >
          {phoneNumber}
        </button>
      </MetaBlock>
    );
  }
);
